import { NavigationEnd, Params } from '@angular/router';
import { createAction, props } from '@ngrx/store';
import { StepModel } from '@classifieds-sell/shared';
import { IRouterState, StepInfo } from './router.models';

export const setRouterStepId = createAction(
    '[Router] Setting Router Step Id',
    props<{ stepId: string }>()
);

export const setRouterStepInfo = createAction(
    '[Router] Setting Router Step Info',
    props<{ stepInfo: StepInfo }>()
);

export const ngRouterStateUpdatedAction = createAction(
    '[Router] Ng - Router State Updated Action',
    props<{ event: NavigationEnd, queryParams: Params }>()
);

export const updateRouterStateAction = createAction(
    '[Router] Update Router State Action',
    props<{ router: IRouterState }>()
);

export const updateSteps = createAction(
    '[Router] Updating Steps',
    props<{ steps: StepModel[] }>()
);
